import React from 'react';
import PropTypes from 'prop-types';
import useDataContext from 'data/context/data';

import { PairCards } from './productDetails';

/**
 * Replaces the generic "not available" alert of the PDP top section when the
 * product content sets `unavailable` (docs/product-page.md): a neutral note
 * plus cards for the alternative products.
 */
const UnavailableNotice = ({ unavailable, linkedContent = [] }) => {
  const dataContext = useDataContext();

  const contentById = Object.fromEntries(linkedContent.map((item) => [item.id, item]));
  const items = dataContext
    .getProducts(unavailable.alternatives)
    .filter((product) => contentById[product.id])
    .map((product) => ({ product, content: contentById[product.id] }));

  return (
    <div className="pdp-unavailable">
      <p className="pdp-unavailable-note">{unavailable.note}</p>
      {items.length > 0 && <PairCards items={items} />}
    </div>
  );
};

UnavailableNotice.propTypes = {
  unavailable: PropTypes.shape({
    note: PropTypes.string.isRequired,
    alternatives: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  linkedContent: PropTypes.arrayOf(PropTypes.object),
};

export default UnavailableNotice;
